// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"ff16554c311016ef8b0a","655":"24dbdb589cbcce380519"}[chunkId] + ".js";
};